// Expose moment on window for libraries that expect it as a global (e.g., daterangepicker)
import moment from "moment";
window.moment = moment;
